import { getItemsFromCollection } from "directus/src/operations";

export async function fetchPendingReviewEntriesForReviewer() {
  try {
    const query = {
      fields: ["logged_hours"],
      filter: {
        approved_hours: { _null: true },
        unapproved_hours: { _null: true },
        logged_hours: { _gt: 0 },
        reviewer: { user: { _eq: "$CURRENT_USER" } },
      },
    };

    const response = await getItemsFromCollection("timesheet", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
